// Import Swiper core and required modules
import Swiper, { Autoplay, EffectFlip, Navigation } from 'swiper';

// Function to initialize hero sliders
const initializeHeroSliders = () => {
    const heroSliders = document.querySelectorAll(".swiper.hero-slider");

    heroSliders.forEach((slider) => {
        new Swiper(slider, {
            modules: [Autoplay, EffectFlip], // Specify modules explicitly
            loop: true,
            effect: "flip",
            grabCursor: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        });
    });
};

// Function to initialize collection sliders
const initializeCollectionSliders = () => {
    const collectionSliders = document.querySelectorAll(".swiper.collection-slider");

    collectionSliders.forEach((slider) => {
        // Reference the parent element (.relative) to find the arrows
        const parent = slider.closest('.relative');

        new Swiper(slider, {
            modules: [Navigation],
            slidesPerView: 1.5,
            spaceBetween: 16,
            navigation: {
                nextEl: parent.querySelector('.custom-button-next'),
                prevEl: parent.querySelector('.custom-button-prev'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
            },
        });
    });
};

// Initialize all sliders on DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
    initializeHeroSliders();
    initializeCollectionSliders();
});
